import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;

  .inputLoader {
    position: absolute;
    right: 0;
    top: calc(50% - 18px);
  }
`;

export const ReplyContainerOnTopOfInput = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #e8e8e8;
  padding-left: 1.25rem;
  padding-top: 0.5rem;

  & > div {
    width: 100%;
  }

  & > div:first-child {
    display: flex;
    justify-content: flex-start;
  }

  & > div:last-child {
    display: flex;
    justify-content: flex-end;
  }

  button {
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    background-color: #e8e8e8;
  }
`;
